import { distanceKm } from "@/lib/map";

const pathLen = (start, list) =>
  list.reduce((sum, p, i) => sum + distanceKm(i === 0 ? start || list[0] : list[i - 1], p), 0);

// nearest-neighbour then 2-opt on an open path (straight-line distance)
export function optimizeRoute(start, stops) {
  if (stops.length < 2) return stops;
  if (!start) {
    let best = null;
    stops.forEach((s) => {
      const r = [s, ...optimizeRoute(s, stops.filter((x) => x !== s))];
      if (!best || pathLen(null, r) < pathLen(null, best)) best = r;
    });
    return best;
  }
  const left = [...stops];
  const order = [];
  let cur = start;
  while (left.length) {
    let best = 0;
    left.forEach((p, i) => {
      if (distanceKm(cur, p) < distanceKm(cur, left[best])) best = i;
    });
    cur = left.splice(best, 1)[0];
    order.push(cur);
  }
  let improved = true;
  let route = order;
  while (improved) {
    improved = false;
    for (let i = 0; i < route.length - 1; i++) {
      for (let k = i + 1; k < route.length; k++) {
        const next = [...route.slice(0, i), ...route.slice(i, k + 1).reverse(), ...route.slice(k + 1)];
        if (pathLen(start, next) + 1e-9 < pathLen(start, route)) {
          route = next;
          improved = true;
        }
      }
    }
  }
  return route;
}

export const legKm = (start, route) => route.map((p, i) => (i === 0 ? (start ? distanceKm(start, p) : 0) : distanceKm(route[i - 1], p)));

export function directionsUrl(start, route) {
  const fmt = (p) => `${p.lat},${p.lng}`;
  const pts = route.slice(0, 10);
  const params = new URLSearchParams({ api: "1", travelmode: "driving", destination: fmt(pts[pts.length - 1]) });
  if (start) params.set("origin", fmt(start));
  const mid = pts.slice(0, -1);
  if (mid.length) params.set("waypoints", mid.map(fmt).join("|"));
  return `https://www.google.com/maps/dir/?${params.toString()}`;
}

export const localDay = (d = new Date()) => {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};
